// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S5qfZ","logo":"styles_logo__mM2gp","heading":"styles_heading__sGi5Q"};